<template>
  <div class="layout-container">
    <TopNav @company-change="refreshHome" />
    <div class="main-wrapper">
      <router-view :key="routerViewKey" />
    </div>
  </div>
</template>

<script>
import TopNav from '@/components/TopNav.vue'

export default {
  name: 'Layout',
  components: {
    TopNav
  },
  data() {
    return {
      homeRefreshKey: 0
    }
  },
  computed: {
    routerViewKey() {
      if (this.$route.path === '/home') {
        return `${this.$route.fullPath}-${this.homeRefreshKey}`
      }
      return this.$route.fullPath
    }
  },
  methods: {
    refreshHome() {
      if (this.$route.path === '/home') {
        this.homeRefreshKey += 1
      }
    }
  }
}
</script>

<style lang="less" scoped>
.layout-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f0f2f5;
  overflow: hidden;
}

.main-wrapper {
  flex: 1;
  min-height: 0;
  overflow: auto;
}
</style>
